module.exports = __webpack_public_path__ + "static/media/ok.6ae97fcc.svg";